import React, { useEffect, useState } from 'react'
import { MultiSelect } from '@ublique/components/Dropdown'
import { isEmpty, uniqueId } from 'lodash'

const SearchColumns = (props) => {
  const { items, onChangeValue, selected, t } = props
  const [key, setKey] = useState()
  useEffect(() => {
    if (!isEmpty(items)) {
      setKey(uniqueId())
    }
  }, [selected])

  return (
    <MultiSelect.Filterable
      key={key}
      placeholder='Search'
      initialSelectedItems={selected}
      id='filterable-lock-columns'
      items={items}
      label={t('Document:LockColumnsModal.SEARCH_LABEL')}
      titleText={t('Document:LockColumnsModal.SEARCH_LABEL')}
      size='lg'
      onChange={onChangeValue}
    />
  )
}

export default SearchColumns
